import { render, staticRenderFns } from "./ChangeAddressModal.vue?vue&type=template&id=5aad90de&scoped=true&"
import script from "./ChangeAddressModal.vue?vue&type=script&lang=js&"
export * from "./ChangeAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aad90de",
  null
  
)

export default component.exports